import React, {
  Fragment,
  useCallback,
  useEffect,
  useReducer,
  useState,
  useMemo,
} from "react";
import { Link } from "react-router-dom";
import { Card, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  usePagination,
} from "react-table";
import { TailSpin } from "react-loader-spinner";

import { COLUMNS } from "./Columns";
import { GlobalFilter } from "./GlobalFilter";

import ModalAgregarClientes from "../sis/ModalFacturacion/ModalAgregarCliente";
import ModalCliente from "../sis/ModalFacturacion/ModalCliente";

import {
  getAllClientes,
  saveCliente,
  isClienteDuplicado,          // ← NUEVO
} from "../../../Api/cliente";

/* ────────────────────────────── */
/* Helpers para MAYÚSCULAS        */
/* ────────────────────────────── */
function toUpperCaseTextPreservingHtml(str) {
  if (typeof str !== "string") return str;
  let r = str.replace(/([^<>]+)(?=<|$)/g, (m) => m.toUpperCase());
  return r.replace(/&NBSP;/gi, "&nbsp;");
}
function toUpperCaseObject(obj) {
  if (typeof obj !== "object" || obj === null) {
    return typeof obj === "string" ? toUpperCaseTextPreservingHtml(obj) : obj;
  }
  if (Array.isArray(obj)) return obj.map(toUpperCaseObject);
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [k, toUpperCaseObject(v)])
  );
}

/* ────────────────────────────── */
/* Reducer para modales           */
/* ────────────────────────────── */
const showReducer = (cur, a) => {
  switch (a.type) {
    case "SHOW":
      return { ...cur, isShow: true, typeModal: a.typeModal };
    case "END":
      return { ...cur, isShow: false };
    default:
      return cur;
  }
};

/* ────────────────────────────── */
/* Componente principal           */
/* ────────────────────────────── */
const Clientes = () => {
  /* Estados */
  const [loading, setLoading] = useState(true);
  const [reducer, dispatchReducer] = useReducer(showReducer, {
    isShow: false,
    typeModal: null,
  });
  const [data, setData] = useState([]);

  /* Obtener clientes */
  const assigmentValue = useCallback(async () => {
    try {
      const result = await getAllClientes();
      setData([...result]);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    assigmentValue();
  }, [assigmentValue]);

  /* Abrir/Cerrar modal */
  const handleShow4 = () => dispatchReducer({ type: "SHOW", typeModal: "CLIENTE" });
  const onCloseModal = () => dispatchReducer({ type: "END" });

  /* Tabla */
  const columns = useMemo(() => COLUMNS, []);
  const tableInstance = useTable(
    { columns, data, initialState: { pageIndex: 0 } },
    useFilters,
    useGlobalFilter,
    usePagination
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;
  const { globalFilter, pageIndex } = state;

  /* ────────────────────────────── */
  /* Guardar cliente (desde modal)  */
  /* ────────────────────────────── */
  const onReturnDataCliente = async (formData) => {
    try {
      Swal.fire({
        title: "Cargando",
        html: "Cargando datos…",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      const dataUpper = toUpperCaseObject(formData);

      /* 1. Chequeo duplicado */
      const duplicate = await isClienteDuplicado({
        telefono: dataUpper.telefono,
        nombre: dataUpper.nombre,
        ruc: dataUpper.ruc,
      });
      let isDuplicated  = duplicate.isDuplicate;
      let fieldDuplicated = duplicate.field;
      console.log(duplicate)
      if (isDuplicated) {
        const { isConfirmed } = await Swal.fire({
          icon: "warning",
          title: "Cliente duplicado",
          text:
            `El  campo ${fieldDuplicated} ya existe. ¿Desea continuar?`,
          confirmButtonText: "Sí, guardar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          confirmButtonColor: "#00273a",
          cancelButtonColor: "#d33",
        });
        if (!isConfirmed) {
          Swal.close();
          return;
        }
      }

      /* 2. Guardar */
      await saveCliente({ ...dataUpper, isNew: true });

      /* 3. Refrescar tabla */
      const listResult = await getAllClientes();
      setData([...listResult]);

      Swal.fire({
        title: "Cliente cargado",
        text: "Se cargó correctamente el cliente.",
        icon: "success",
        confirmButtonColor: "black",
      });
      dispatchReducer({ type: "END" });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Oops…",
        text: `${err}`,
      });
    } finally {
      Swal.close();
    }
  };

  /* ────────────────────────────── */
  /* Render                         */
  /* ────────────────────────────── */
  return (
    <Fragment>
      <div className="col-md-12">
        <div className="card">
          <div className="card-body pb-0">
            <div className="row justify-content-between">
              <div className="col-auto">
                <Card.Title>Clientes</Card.Title>
              </div>
              <div className="col-auto">
                <h5>
                  <Button onClick={handleShow4}>Agregar</Button>
                </h5>
              </div>
            </div>
          </div>

          {/* Tabla */}
          <div className="chart-wrapper">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />

                  <TailSpin
                    height="30"
                    width="30"
                    color="Black"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    visible={loading}
                  />
                  <br />

                  <table {...getTableProps()} className="table dataTable display">
                    <thead>
                      {headerGroups.map((hg) => (
                        <tr {...hg.getHeaderGroupProps()}>
                          {hg.headers.map((col) => (
                            <th {...col.getHeaderProps()}>
                              {col.render("Header")}
                              {col.canFilter ? col.render("Filter") : null}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => (
                              <td {...cell.getCellProps()} className="p-2">
                                <Link to={`/FichaCliente/${row.values.idClientes}`}>
                                  {cell.render("Cell")}
                                </Link>
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {/* Paginación */}
                  <div className="d-flex justify-content-between">
                    <span>
                      Page{" "}
                      <strong>
                        {pageIndex + 1} of {pageOptions.length}
                      </strong>
                    </span>
                    <span className="table-index">
                      Go to page:{" "}
                      <input
                        type="number"
                        defaultValue={pageIndex + 1}
                        onChange={(e) =>
                          gotoPage(e.target.value ? Number(e.target.value) - 1 : 0)
                        }
                      />
                    </span>
                  </div>
              <div className="text-center mb-3">
                    <div className="filter-pagination  mt-3">
                      <button
                        className=" previous-button"
                        onClick={() => gotoPage(0)}
                        disabled={!canPreviousPage}
                      >
                        {"<<"}
                      </button>

                      <button
                        className="previous-button"
                        onClick={() => previousPage()}
                        disabled={!canPreviousPage}
                      >
                        Previous
                      </button>
                      <button
                        className="next-button"
                        onClick={() => nextPage()}
                        disabled={!canNextPage}
                      >
                        Next
                      </button>
                      <button
                        className=" next-button"
                        onClick={() => gotoPage(pageCount - 1)}
                        disabled={!canNextPage}
                      >
                        {">>"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modales */}
      {reducer.isShow && (
        <ModalAgregarClientes
          estado={reducer.isShow}
          onCloseModal={onCloseModal}
          onReturnValue={onReturnDataCliente}
          Editdata={[
            {
              nombre: "",
              razonsocial: "",
              ruc: "",
              Ciudad: "",
              direccion: "",
              telefono: "",
              correo: "",
            },
          ]}
        />
      )}
    </Fragment>
  );
};

export default Clientes;
